import script from "./CustomCursor.vue?vue&type=script&setup=true&lang=js"
export * from "./CustomCursor.vue?vue&type=script&setup=true&lang=js"

import "./CustomCursor.vue?vue&type=style&index=0&id=203744ad&lang=css"

const __exports__ = script;

export default __exports__